<template>
    <DefaultLayout
      :pageTitle="meta.title"
      :pageDescription="meta.description"
      :showFooterCTA="false"
    >
      <PageHeader
        title="Partner with Capsule <br> and Transpond"
        subtitle-text="Join the Capsule and Transpond Partner Program. Help businesses grow with an easy-to-use CRM and marketing solution. Earn up to 30% lifetime commission for every paying customer you refer."
        class="mb-0 sm:mb-0 no-submenu"
        textAlign="left"
      >
        <template v-slot:image>
          <PageHeaderImage image="feature-hero"></PageHeaderImage>
        </template>
      </PageHeader>

      <SectionTwoColumnHeadingParagraphs
      title="Grow your income by recommending Capsule and Transpond"
      theme="grey"
      :paragraphs="[
        'Capsule and Transpond make it easy for businesses to manage their relationships, sales, and marketing all in one place. Why not be part of their journey?',
        'Our Partner Program gives you everything you need to recommend solutions that your clients will love, and you can earn up to 30% commission for the lifetime of every customer you bring on board.',
      ]"
    ></SectionTwoColumnHeadingParagraphs>
  
      <SectionTwoColumnAccordionLeft
      title="Why Partner with Capsule and Transpond?"
      content="Whether you are a business consultant, marketing expert, content creator, or a trusted advisor to growing businesses, partnering with us is a simple way to add new revenue streams — while delivering more value to your clients."
      image="capsule-partners"
      theme="dark"
      class="!mt-0"
      :accordion="[
        {
          name: 'Earn up to 30% lifetime commission',
          content:
            'For every paying customer you refer you earn up to 30% lifetime commission.',
        },
        {
          name: 'Easy to recommend',
          content:
            'Just share your link - Capsule and Transpond are easy to use, quick to implement, and loved by thousands of small businesses around the world.',
        },
        {
          name: 'Complete support',
          content:
            'Access onboarding guides, marketing resources, dedicated account management and a partner community designed to help you succeed and grow.',
        },
        {
          name: 'Solutions in perfect sync',
          content:
            ' Capsule CRM and Transpond are a natural fit, offering your clients a complete customer management and marketing solution.',
        },
      ]"
    ></SectionTwoColumnAccordionLeft>
  
    <SectionTwoColumnRight
      title="Transactional Email"
      content="Set up emails to be sent directly from your website or app for onboarding, order confirmations and much more. Transpond's transaction emails are easy to set up, and deliver a full set of analytics to let you see what's going on."
      image="transaction-email"
      button-text="Learn more"
      button-link="TransactionalEmails"
    ></SectionTwoColumnRight>
  
      <SectionOneColumnCenter
        id="automations"
        title="Join a growing community of successful partners"
        content="We work closely with our partners every step of the way to provide you with the tools, resources, and support you need to start strong and scale. Whether you recommend Capsule, Transpond, or both, our program is built to reward your efforts and help you grow."
        button-text="Discover our Partner Program"
        button-link="https://capsulecrm.com/partner-program/"
      ></SectionOneColumnCenter>
  
    </DefaultLayout>
  </template>
  
  <script>
  import DefaultLayout from "@/layouts/DefaultLayout.vue";
  import PageHeader from "@/components/Header/PageHeader";
  import PageHeaderImage from "@/components/Header/PageHeaderImage";
  import SectionOneColumnCenter from "@/components/ContentSections/SectionOneColumnCenter";
  import SectionTwoColumnAccordionLeft from "@/components/ContentSections/SectionTwoColumnAccordionLeft";
  import SectionTwoColumnHeadingParagraphs from "@/components/ContentSections/SectionTwoColumnHeadingParagraphs";
  export default {
    name: "MailchimpAlternative",
    components: {
        DefaultLayout,PageHeader, PageHeaderImage, SectionOneColumnCenter, SectionTwoColumnAccordionLeft, SectionTwoColumnHeadingParagraphs
    },
    data() {
      return {
        meta: {
          title: "Partner Program | Earn Lifetime Commissions",
          description:
            "Join the Capsule and Transpond Partner Program. Help businesses grow with an easy-to-use CRM and marketing solution. Earn up to 30% lifetime commission for every paying customer you refer.",
        },
      };
    },
    methods: {
      openWindow: function (link, self) {
        window.open(link, self ? "_self" : "_blank");
      },
    },
  };
  </script>